import { combineReducers, configureStore, createAction } from "@reduxjs/toolkit";
import superSpinReducer from "../GameOriginal/superSpin/superSpinSlice";
import modalOrchestratorReducer from "../modalOrchestrator/modalOrchestratorSlice";
import rechargeSpinReducer from "../../pages/rechargeSpinActivity/rechargeSpinSlice";

const appReducer = combineReducers({
  // originalGame: originalGameReducer,
  superSpin: superSpinReducer,
  modalOrchestrator: modalOrchestratorReducer,
  rechargeSpin: rechargeSpinReducer,
});

export const resetSessionState = createAction("session/reset");

const rootReducer: typeof appReducer = (state, action) => {
  if (resetSessionState.match(action)) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sporesChangeMiddleware),
});

// 从store本身推断出RootState和AppDispatch类型
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
